import React from 'react';
import { Link } from 'react-router-dom';

function InterviewDayGuide({ darkMode }) {
  const containerClass = darkMode 
    ? 'min-h-screen bg-gray-900 text-white' 
    : 'min-h-screen bg-gradient-to-br from-yellow-50 to-orange-100 text-gray-800';

  const cardClass = darkMode 
    ? 'bg-gray-800 border-gray-700' 
    : 'bg-white border-gray-200';

  return (
    <div className={containerClass}>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* 헤더 */}
        <div className="text-center mb-12">
          <div className="text-6xl mb-4">⏰</div>
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent">
            면접 당일 완벽 준비 체크리스트
          </h1>
          <p className="text-xl text-gray-600 mb-6">
            시간 관리부터 마인드셋까지 완벽 준비
          </p>
          <div className={`inline-block px-6 py-3 rounded-full text-sm font-semibold ${darkMode ? 'bg-yellow-900 text-yellow-200' : 'bg-yellow-100 text-yellow-800'}`}>
            💡 준비가 철저할수록 자신감이 생겨요!
          </div>
        </div>

        {/* 면접 전날 밤 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">🌅 면접 전날 밤 (D-1)</h2>
          
          <div className="space-y-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-yellow-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-yellow-600">📋 준비물 최종 체크</h3>
              <ul className="space-y-2">
                <li>• 📋 면접 장소, 시간, 담당자 연락처 재확인</li>
                <li>• 👔 면접 복장 준비 (다림질, 신발 광택)</li>
                <li>• 📁 서류 준비 (이력서, 자기소개서, 증명서 여분)</li>
                <li>• 🎒 가방 정리 (필기구, 물티슈, 손수건)</li>
                <li>• 📱 스마트폰 충전, 길찾기 앱 설치</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-orange-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-orange-600">🛁 컨디션 관리</h3>
              <ul className="space-y-2">
                <li>• 🛁 일찍 씻고 일찍 잠자리</li>
                <li>• 🚫 술, 기름진 음식 피하기</li>
                <li>• 📚 면접 예상 질문 마지막 점검</li>
                <li>• 🧘‍♀️ 가벼운 스트레칭으로 긴장 완화</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 면접 당일 아침 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">🌄 면접 당일 아침</h2>
          
          <div className="space-y-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-yellow-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-yellow-600">⏰ 기상 후 (면접 3-4시간 전)</h3>
              <ul className="space-y-2">
                <li>• ⏰ 여유롭게 기상 (늦잠 절대 금지)</li>
                <li>• 🥗 가벼운 아침 식사 (배가 고프면 집중력 떨어짐)</li>
                <li>• ☕ 카페인 적당히 (너무 많으면 떨림)</li>
                <li>• 🪞 거울 앞에서 자기소개 연습</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-orange-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-orange-600">👗 외출 준비 (면접 1-2시간 전)</h3>
              <ul className="space-y-2">
                <li>• 👗 복장 최종 체크 (구김, 얼룩 확인)</li>
                <li>• 💄 헤어/메이크업 (자연스럽게)</li>
                <li>• 🎒 준비물 가방에 넣기</li>
                <li>• 🚗 교통편 및 경로 재확인</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 이동 중 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">🚇 이동 중</h2>
          
          <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-yellow-50'}`}>
            <h3 className="text-xl font-bold mb-4 text-yellow-600">🚌 교통 이용 시</h3>
            <ul className="space-y-2">
              <li>• ⏰ 30분 일찍 출발 (여유시간 확보)</li>
              <li>• 🎧 차분한 음악 듣기 (긴장 완화)</li>
              <li>• 📱 면접 장소 길찾기 재확인</li>
              <li>• 😮‍💨 심호흡으로 마음 다스리기</li>
            </ul>
          </div>
        </div>

        {/* 면접 장소 도착 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">🏢 면접 장소 도착 (15분~20분 전)</h2>
          
          <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-yellow-50'}`}>
            <h3 className="text-xl font-bold mb-4 text-yellow-600">🚻 도착 후 할 일</h3>
            <div className="space-y-3">
              <p className="font-semibold text-orange-600">화장실에서 마지막 체크:</p>
              <ul className="space-y-2 ml-4">
                <li>• 헤어스타일, 옷 상태 점검</li>
                <li>• 양치 또는 가글로 입 냄새 체크</li>
                <li>• 손 씻기, 손톱 정리</li>
              </ul>
              <div className="mt-4 space-y-2">
                <li>• 📱 스마트폰 무음 모드</li>
                <li>• 📄 서류 마지막 확인</li>
                <li>• 🧘‍♀️ 잠깐 명상하며 마음 정리</li>
              </div>
            </div>
          </div>
        </div>

        {/* 면접 직전 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">💼 면접 직전 (5분 전)</h2>
          
          <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-yellow-50'}`}>
            <h3 className="text-xl font-bold mb-4 text-yellow-600">🎯 최종 점검</h3>
            <ul className="space-y-2">
              <li>• 😊 밝은 표정 연습</li>
              <li>• 🤝 악수 연습 (적당한 힘, 2-3초)</li>
              <li>• 📝 핵심 답변 포인트 머릿속으로 정리</li>
              <li>• 💪 "할 수 있다!" 자신감 충전</li>
            </ul>
          </div>
        </div>

        {/* 면접 중 주의사항 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">🎯 면접 중 주의사항</h2>
          
          <div className="space-y-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-green-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-green-600">🚪 입실 시</h3>
              <ul className="space-y-2">
                <li>• 🚪 노크 3번, "들어가겠습니다"</li>
                <li>• 🙇‍♀️ 정중한 인사</li>
                <li>• 🪑 의자 끌지 말고 조용히 앉기</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-blue-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-blue-600">💬 면접 진행 중</h3>
              <ul className="space-y-2">
                <li>• 👀 면접관과 적절한 아이컨택</li>
                <li>• 📢 또렷하고 적당한 목소리 크기</li>
                <li>• ⏱️ 답변 시간 조절 (너무 길거나 짧지 않게)</li>
                <li>• 😌 실수해도 당황하지 말고 차분하게</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 면접 후 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-yellow-600">🎉 면접 후</h2>
          
          <div className="space-y-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-purple-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-purple-600">🚪 퇴실 시</h3>
              <ul className="space-y-2">
                <li>• 🙏 감사 인사 ("귀한 시간 내주셔서 감사합니다")</li>
                <li>• 🚪 문 닫을 때까지 예의 지키기</li>
                <li>• 🚶‍♀️ 건물 밖으로 나올 때까지 긴장 유지</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-indigo-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-indigo-600">📝 면접 종료 후</h3>
              <ul className="space-y-2">
                <li>• 📝 면접 내용 기록해두기</li>
                <li>• 📧 감사 이메일 고려 (회사 문화에 따라)</li>
                <li>• 🎯 다음 면접 준비 또는 휴식</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 절대 하면 안 되는 것들 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-red-600">🚨 절대 하면 안 되는 것들</h2>
          
          <div className="space-y-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-red-600">❌ 시간 관련</h3>
              <ul className="space-y-2">
                <li>• 지각 (5분도 안 됨!)</li>
                <li>• 너무 일찍 도착 (1시간 이상 일찍)</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-red-600">❌ 복장/외모</h3>
              <ul className="space-y-2">
                <li>• 새 옷, 새 신발 착용 (불편할 수 있음)</li>
                <li>• 진한 향수나 화장</li>
                <li>• 손톱에 화려한 네일아트</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-red-600">❌ 행동</h3>
              <ul className="space-y-2">
                <li>• 스마트폰 만지작거리기</li>
                <li>• 다리 떨기, 펜 돌리기</li>
                <li>• 면접관보다 먼저 악수 청하기</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-red-600">❌ 멘탈</h3>
              <ul className="space-y-2">
                <li>• "떨어질 것 같다" 부정적 생각</li>
                <li>• 다른 지원자와 비교하기</li>
                <li>• 과도한 긴장으로 몸 경직</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 프로 팁 */}
        <div className={`${cardClass} rounded-2xl p-8 mb-8 border shadow-lg`}>
          <h2 className="text-2xl font-bold mb-6 text-green-600">💡 프로 팁</h2>
          
          <div className="space-y-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-green-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-green-600">✅ 긴장 완화법</h3>
              <ul className="space-y-2">
                <li>• 4-7-8 호흡법 (4초 들이쉬고, 7초 참고, 8초 내쉬기)</li>
                <li>• 어깨 돌리기로 몸 풀기</li>
                <li>• "면접관도 사람이다" 마인드</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-blue-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-blue-600">✅ 자신감 충전법</h3>
              <ul className="space-y-2">
                <li>• 거울 보며 웃는 연습</li>
                <li>• "나는 이 회사에 도움이 되는 사람이다" 되뇌기</li>
                <li>• 성공 경험 떠올리기</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-purple-50'}`}>
              <h3 className="text-xl font-bold mb-4 text-purple-600">✅ 마지막 조언</h3>
              <div className="space-y-3">
                <p className="font-semibold text-purple-600">완벽하지 않아도 괜찮아요</p>
                <p className="font-semibold text-purple-600">진정성이 가장 중요해요</p>
                <p className="font-semibold text-purple-600">이것도 하나의 경험이에요</p>
              </div>
            </div>
          </div>

          {/* 연습 포인트 */}
          <div className={`p-4 rounded-xl ${darkMode ? 'bg-yellow-900 bg-opacity-30' : 'bg-yellow-100'} mt-6`}>
            <p className="text-sm font-semibold text-yellow-600">체크리스트 활용법:</p>
            <ul className="text-sm mt-2 space-y-1">
              <li>• 면접 3일 전부터 이 체크리스트 반복 확인</li>
              <li>• 실제 면접 당일에는 스마트폰에 저장해서 확인</li>
              <li>• 각 단계별로 체크하면서 진행하기</li>
              <li>• 무엇보다 자신감을 가지고 임하기!</li>
            </ul>
          </div>
        </div>

        {/* 네비게이션 버튼 */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link 
            to="/guide-success" 
            className={`px-8 py-4 rounded-xl font-semibold transition-all duration-300 text-center ${
              darkMode 
                ? 'bg-gray-700 text-white hover:bg-gray-600' 
                : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
            }`}
          >
            ← 면접성공가이드 메인으로
          </Link>
          <Link 
            to="/" 
            className="px-8 py-4 bg-gradient-to-r from-yellow-600 to-orange-600 text-white rounded-xl font-semibold hover:from-yellow-700 hover:to-orange-700 transition-all duration-300 text-center"
          >
            🏠 홈으로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  );
}

export default InterviewDayGuide;